import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

export const ShowYourDoctorSection = styled.div<{ isLoggedIn: boolean }>`
  margin: 0 ${props => (props.isLoggedIn ? '0' : props.theme.space['2.0'])};
  ${props => props.theme.mediaQueries.medium} {
    max-width: 560px;
    margin: 0 ${props => (props.isLoggedIn ? '0' : 'auto')};
  }
`;

export const PillTriangleSVG = styled(InlineSVG)`
  svg {
    width: 67px;
    height: 60px;
    position: absolute;
    top: 220px;
    right: -25px;
    * {
      fill: ${props => props.theme.colors.capsuleYellow};
    }
  }
  ${props => props.theme.mediaQueries.medium} {
    svg {
      width: 200px;
      height: 178px;
      position: absolute;
      top: 180px;
      right: -50px;
      z-index: 0;
    }
  }
`;

export const PillSectionSVG = styled(InlineSVG)`
  svg {
    width: 67px;
    height: 74px;
    position: absolute;
    transform: rotate(-54deg);
    bottom: 25px;
    left: -25px;
    * {
      fill: ${props => props.theme.colors.capsuleGreen50};
    }
  }
  ${props => props.theme.mediaQueries.medium} {
    svg {
      width: 200px;
      height: 220px;
      position: absolute;
      bottom: 25px;
      left: -70px;
      z-index: 0;
    }
  }
`;
